// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"ecd3db7d","377":"d4fb0a9a","379":"0fe452b6","462":"871ba6c8","526":"fc3124c1"}[chunkId] + ".chunk.js";
};